/* Imports */
import React from "react"
import { Font, Tabs } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"

const TabsPage = () => {
    const tabsItems = [
        {
            title: "Tab 1",
            content: "Content tab 1",
        },
        {
            title: "Tab 2",
            content: (
                <>
                    <Font.P>Hello</Font.P>
                    <Font.P>World</Font.P>
                </>
            ),
        },
        {
            title: "Tab 3",
            content: "Content tab 3",
        },
    ]

    const items = [
        {
            content: <Tabs items={tabsItems} />,
            code: 'const tabsItems = [\n    {\n        title: "Tab 1",\n        content: "Content tab 1",\n    },\n    {\n        title: "Tab 2",\n        content: (\n            <>\n                <Font.P>Hello</Font.P>\n                <Font.P>World</Font.P>\n            </>\n        ),\n    },\n    {\n        title: "Tab 3",\n        content: "Content tab 3",\n    },\n]\n\n<Tabs items={tabsItems} />',
        },
    ]

    const propsItems = [
        {
            name: "items",
            type: "Array of objects",
            example: "",
            possible: "",
            default: "",
            required: "Yes",
        },
        {
            name: "title (items Object)",
            type: "String",
            example: "Tab 1",
            required: "Yes",
        },
        {
            name: "content (items Object)",
            type: "String or JSX Element",
            required: "Yes",
        },
        {
            name: "active",
            type: "Number (from 0)",
            example: "2",
            default: "0",
        },
    ]

    return <ComponentPage items={items} propsItems={propsItems} />
}

export default TabsPage
